import gsap from 'gsap'
import ScrollTrigger from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger);

export default function() {
	// Scroll animations system with GSAP
	let sections = gsap.utils.toArray('[twk-aos]');
	let onFirstBlock = false;

	sections.forEach((section) => {
		// Check if the section is the first block on the main container.
		// We want it to animate earlier than the others.
		if ( section.closest('section') !== null ){
			const parent         = document.querySelector('main.main');
			const firstSectionId = parent?.firstElementChild.id

			if ( section.closest('section').id === firstSectionId ) {
				onFirstBlock = true;
			} else {
				onFirstBlock = false;
			}
		}

		// Defaults
		let twkAosTrigger  = ( onFirstBlock ? 'top bottom-=20px' : 'top bottom-=150px' );
		let twkAosDuration = 0.8;
		let twkAosDelay    = '<';
		let twkAosStagger  = 0.2;
		let twkAosMarker   = false;
		let twkAosMarkerId = 'section';

		if ( section.getAttribute('twk-aos-trigger') !== null ){
			twkAosTrigger = section.getAttribute('twk-aos-trigger');
		}
		if ( section.getAttribute('twk-aos-duration') !== null ){
			twkAosDuration = section.getAttribute('twk-aos-duration') / 1000;            // From html we get them in milliseconds
		}
		if ( section.getAttribute('twk-aos-delay') !== null ){
			twkAosDelay = section.getAttribute('twk-aos-delay') / 1000;                  // From html we get them in milliseconds
		}
		if ( section.getAttribute('twk-aos-stagger') !== null ){
			// Check if result is NaN - which will mean we didn't set a value
			// and so we want the default.
			if ( ! Number.isNaN(parseInt(section.getAttribute('twk-aos-stagger'))) ){
				twkAosStagger = section.getAttribute('twk-aos-stagger') / 1000;          // From html we get them in milliseconds
			}
		}
		if ( section.getAttribute('twk-aos-marker') !== null ){
			twkAosMarker  = true;
			twkAosMarkerId = section.getAttribute('twk-aos-marker');
		}


		/* 
		// Log data.
		console.table({
			'twk-aos-trigger' : { 'Value': twkAosTrigger },
			'twk-aos-duration' : {'Value': twkAosDuration },
			'twk-aos-delay' : {'Value': twkAosDelay },
			'twk-aos-marker' : {'Value': twkAosMarker },
			'HTML' : {'Value': section }
		});
		*/


		let tl = gsap.timeline({
			defaults: {
				duration: twkAosDuration,
				ease: "power1.out",
				immediateRender: false,
			},
			scrollTrigger: {
				trigger: section,
				fastScrollEnd: true,
				once: true,
				start: twkAosTrigger,
				end: "bottom 85%", // fastScrollEnd triggers as we leave the section so make sure you have an end position set low down enough to see the impact.
				id: twkAosMarkerId,
				markers: twkAosMarker,
				triggerHook: 1,
				toggleClass: 'twk-aos-animating',
				onEnter: () => section.classList.add('twk-aos-animate'),
				onLeave: () => section.classList.add('twk-aos-animated'),
			}
		});

		/**
		 * Scroll animations
		 * 
		 * Options:
		 * fade, fade-up, fade-down, fade-left, fade-right
		 * slide-up, slide-down, slide-left, slide-right
		 * zoom-in, zoom-out
		 */
		let animationObject;
		let animationToObject;
		let animationAttr = section.getAttribute('twk-aos');

		// Create the GSAP object for the animation depending on the twk-aos attribute.
		switch ( animationAttr ) {
			case 'fade':
				animationObject = { autoAlpha: 0 }
				animationToObject = { autoAlpha: 1 }
				break;
			case 'fade-up':
				animationObject = { autoAlpha: 0, y: '100px' }
				animationToObject = { autoAlpha: 1, y: '0px' }
				break;
			case 'fade-down':
				animationObject = { autoAlpha: 0, y: '-100px' }
				animationToObject = { autoAlpha: 1, y: '0px' }
				break;
			case 'fade-left':
				animationObject = { autoAlpha: 0, x: '100px', y: 0 }
				animationToObject = { autoAlpha: 1, x: '0px' }
				break;
			case 'fade-right':
				animationObject = { autoAlpha: 0, x: '-100px', y: 0 }
				animationToObject = { autoAlpha: 1, x: '0px' }
				break;
			case 'slide-up':
				animationObject = { x: 0, y: '100px' }
				animationToObject = { y: '0' }
				break;
			case 'slide-down':
				animationObject = { x: 0, y: '-100px' }
				animationToObject = { y: '0' }
				break;
			case 'slide-left':
				animationObject = { x: '100px', y: 0 }
				animationToObject = { x: '0' }
				break;
			case 'slide-right':
				animationObject = { x: '-100px', y: 0 }
				animationToObject = { x: '0' }
				break;
			case 'zoom-in':
				animationObject = { scale: 0.7 }
				animationToObject = { scale: 1 }
				break;
			case 'zoom-out':
				animationObject = { scale: 1.1 }
				animationToObject = { scale: 1 }
				break;
			case 'fade-zoom-in':
				animationObject = { autoAlpha: 0, scale: 0.5 }
				animationToObject = { autoAlpha: 1, scale: 1 }
				break;
		
			default:
				animationObject = { autoAlpha: 0 }
				animationToObject = { autoAlpha: 1 }
				break;
		}
		

		//TODO: make the scrollTrigger work with the stagger. Or make differece between stagger archive and single row.
		if ( section.getAttribute('twk-aos-stagger') !== null ){
			tl.to( section, { opacity: 1, x:0, y: 0, scale: 1 } ) // makes visible the parent div

			// animation on the children
			section.querySelectorAll(":scope > *").forEach(function(block, index) {
				const selector = '[twk-aos-stagger] > .' + gsap.utils.toArray(block)[0].classList[0] + ':nth-child('+(index+1)+')';

				//console.log(selector);
				tl = gsap.timeline({
					scrollTrigger: {
						trigger: selector,
					}
				});

				tl.fromTo(selector, animationObject, animationToObject, twkAosDelay);
			});
		} else {
			// Log data.
			/* console.table({
				'section' : { 'Value': section },
				'animationObject' : { 'Value': JSON.stringify( animationObject ) },
				'animationToObject' : { 'Value': JSON.stringify( animationToObject ) },
				'twkAosDelay' : { 'Value': JSON.stringify( twkAosDelay ) },
			});
			console.log(section); */
			tl.fromTo( section, animationObject, animationToObject, twkAosDelay )
		}



		// Check current scroll position and trigger animations if needed
		const scrollPosition = window.pageYOffset || document.documentElement.scrollTop;

		if ( scrollPosition > 100 ) {
			ScrollTrigger.refresh();
		}
	});




	/* CUSTOM ANIMATIONS */
	function scrollAnimationFadeReveal(){
		const objectToAnimate = document.querySelectorAll( '[data-js="fade-reveal"]' )

		if ( objectToAnimate.length > 0 ) {
			objectToAnimate.forEach(object => {
				let tl = gsap.timeline({
					scrollTrigger: {
						trigger: object,
						start: "top bottom+=50px",
						end: "top top+=50px",
						scrub: 1,
					},
				});
				
				tl.fromTo( object, { clipPath: 'inset(0% 25% 0% 25%)', scale: 0.8 }, { clipPath: 'inset(0% 0% 0% 0%)', scale: 1 } )
			});

		}
	}

	scrollAnimationFadeReveal()

	function scrollAnimationFadeRevealSides(){
		const objectToAnimate = document.querySelectorAll( '[data-js="fade-reveal-left"]' )

		if ( objectToAnimate.length > 0 ) {
			objectToAnimate.forEach(object => {
				let onScrub = true
				let withDelay = 0

				if ( object.dataset.jsOnload ){
					onScrub = false
					withDelay = object.dataset.jsOnload
				}

				let tl = gsap.timeline({
					scrollTrigger: {
						trigger: object,
						start: "top bottom+=50px",
						end: "top center",
						scrub: onScrub,
					},
				});
				
				if ( withDelay > 0 && window.innerWidth > 699 ) {
					tl.to( object, { clipPath: 'inset(0% 100% 0% 0%)', duration: 0 } )
						.fromTo( object, { clipPath: 'inset(0% 100% 0% 0%)'}, { clipPath: 'inset(0% 0% 0% 0%)'}, '+='+withDelay )
				} else {
					tl.fromTo( object, { clipPath: 'inset(0% 100% 0% 0%)', scale: 0.8 }, { clipPath: 'inset(0% 0% 0% 0%)', scale: 1 } )
				}
			});

		}
	}

	scrollAnimationFadeRevealSides()


	function scrollAnimationFadeRevealWithBackground(){
		const objectToAnimateRight = document.querySelectorAll( '[data-js="fade-reveal-with-background-right"]' )
		const objectToAnimateLeft = document.querySelectorAll( '[data-js="fade-reveal-with-background-left"]' )

		if ( objectToAnimateRight.length > 0 ) {
			objectToAnimateRight.forEach(object => {
				const image = object.querySelector('img')
				const background = object.querySelector('.js-background')

				if ( image ) {
					let tl = gsap.timeline({
						scrollTrigger: {
							trigger: image,
							start: "top bottom+=50px",
							end: "top center",
						},
					});
					
					tl.fromTo( image, { clipPath: 'inset(0% 100% 0% 0%)', scale: 0.8 }, { clipPath: 'inset(0% 0% 0% 0%)', scale: 1 } )
				}
				if ( background ) {
					let tl = gsap.timeline({
						delay: 0.2,
						scrollTrigger: {
							trigger: background,
							start: "top bottom+=50px",
							end: "top center",
						},
					});
					
					tl.fromTo( background, { clipPath: 'inset(0% 0% 0% 100%)' }, { clipPath: 'inset(0% 0% 0% 0%)'} )
				}
			});
		}
		
		if ( objectToAnimateLeft.length > 0 ) {
			objectToAnimateLeft.forEach(object => {
				const image = object.querySelector('img')
				const background = object.querySelector('.js-background')

				if ( image ) {
					let tl = gsap.timeline({
						scrollTrigger: {
							trigger: image,
							start: "top bottom+=50px",
							end: "top center",
						},
					});
					
					tl.fromTo( image, { clipPath: 'inset(0% 0% 0% 100%)', scale: 0.8 }, { clipPath: 'inset(0% 0% 0% 0%)', scale: 1 } )
				}
				if ( background ) {
					let tl = gsap.timeline({
						delay: 0.2,
						scrollTrigger: {
							trigger: background,
							start: "top bottom+=50px",
							end: "top center",
						},
					});
					
					tl.fromTo( background, { clipPath: 'inset(0% 100% 0% 0%)' }, { clipPath: 'inset(0% 0% 0% 0%)'} )
				}
			});
		}
	}

	function scrollAnimationMoveUpSrub(){
		const objectToAnimate = document.querySelectorAll( '[data-js="move-up-scrub"]' )

		if ( objectToAnimate.length > 0 ) {
			objectToAnimate.forEach(object => {
				let tl = gsap.timeline({
					scrollTrigger: {
						trigger: object,
						start: "top bottom+=50px",
						end: "top top+=50px",
						scrub: 1,
					},
				});
				
				tl.fromTo( object, { y: 250 }, { y: 0 } )
			});

		}
	}

	scrollAnimationMoveUpSrub()

	scrollAnimationFadeRevealWithBackground()
}
